import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initChatbazeWidget } from "./utils/widgetInit";

// Redirect from chatbaze.id app-paths to app.chatbaze.id (JS fallback — primary redirect is in worker.ts)
// Only redirect if we are genuinely on the apex/www domain. 
// FORCE_APP_SUBDOMAIN is intentionally NOT used here to avoid dev-mode redirecting to production.
const isMainDomain = typeof window !== "undefined" && 
  (window.location.hostname === "chatbaze.id" || window.location.hostname === "www.chatbaze.id");
const isDashboardPath = typeof window !== "undefined" && 
  (window.location.pathname.startsWith("/dashboard") || 
   window.location.pathname.startsWith("/admin") ||
   window.location.pathname.startsWith("/billing") ||
   window.location.pathname.startsWith("/upgrade") ||
   window.location.pathname.startsWith("/guide") ||
   window.location.pathname.startsWith("/login") ||
   window.location.pathname.startsWith("/signup") ||
   window.location.pathname.startsWith("/checkout") ||
   window.location.pathname.startsWith("/forgot-password") ||
   window.location.pathname.startsWith("/reset-password"));

const isAlreadyAppSubdomain = typeof window !== "undefined" && window.location.hostname === "app.chatbaze.id";

if (!isAlreadyAppSubdomain && isMainDomain && isDashboardPath) {
  // Server-side redirect in worker.ts should handle this first; this is a JS fallback.
  window.location.replace(`https://app.chatbaze.id${window.location.pathname}${window.location.search}${window.location.hash}`);
} else {
  // Initialize internal widget
  initChatbazeWidget();
  createRoot(document.getElementById("root")!).render(<App />);
}
